import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AccountModel} from "../../models/account.model";

require('./account-avatar.scss');
@Component({
  standalone: false,
  selector: 'app-account-avatar',
  templateUrl: './account-avatar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountAvatarComponent {

  @Input() account: AccountModel;
  @Input() size: 'small' | 'medium' | 'large';

}
